import { Select } from 'antd';
import { useState } from 'react';

/**
 * Reusable Select column with built-in async onChange loading state
 * and consistent background/text color styling across AntD Select.
 */
const SelectColumn = ({
  value,
  onChangeAsync,
  options = [],
  placeholder,
  size = 'small',
  className,
  style,
  dropdownStyle = { zIndex: 1000 },
  allowClear = false,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = async (newValue) => {
    if (!onChangeAsync) return;
    setIsLoading(true);
    try {
      await onChangeAsync(newValue);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Select
        value={value}
        onChange={handleChange}
        loading={isLoading}
        placeholder={placeholder}
        className={[
          className,
          '[&_.ant-select-selection-item]:!text-[var(--select-color)]',
          '[&_.ant-select-selection-placeholder]:!text-[var(--select-color)]',
          '[&_.ant-select-selector]:!bg-transparent',
          '[&_.ant-select-selection-item]:!bg-transparent',
          '[&_.ant-select-selection-search]:!bg-transparent',
          '[&.ant-select-focused_.ant-select-selector]:!bg-transparent',
          '[&.ant-select-open_.ant-select-selector]:!bg-transparent',
          '[&_.ant-select-selector:hover]:!bg-transparent',
        ].filter(Boolean).join(' ')}
        size={size}
        dropdownStyle={dropdownStyle}
        style={style}
        allowClear={allowClear}
      >
        {options.map((opt) => (
          <Select.Option key={String(opt.value)} value={opt.value} style={opt.style} disabled={opt.disabled}>
            {opt.label}
          </Select.Option>
        ))}
      </Select>
    </>
  );
};

export default SelectColumn;


